import React, { useContext } from "react"
import './M_LateralMenu.css'
import { NavigateContext, LoadingContext } from "../M_Utils"
import { useTranslation } from "react-i18next"
import { Box, ListItemText, ListItemButton, ListItem, IconButton, Tooltip } from '@mui/material'
import Settings from '@mui/icons-material/Settings'
import LogoutIcon from '@mui/icons-material/Logout'
import ArrowRight from '@mui/icons-material/ArrowRight'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUP from '@mui/icons-material/KeyboardArrowUp'
import ChevronRight from '@mui/icons-material/ChevronRight'
import TripOriginIcon from '@mui/icons-material/TripOrigin'
import ListItemIcon from '@mui/material/ListItemIcon'

export default function M_LateralMenu({ showMenu, setShowMenu, menus, setMenus, bodyPage, handleChangeLng, handleLogout, handleSettings }) {
    const ctx = useContext(NavigateContext)
    const ctx2 = useContext(LoadingContext)
    const { t } = useTranslation()
    const name = localStorage.getItem(`accountName`)
    const company = localStorage.getItem(`accountCompany`)
    const primaryColor = ctx2.primaryColor || 'var(--color-black)'
    const secondaryColor = ctx2.secondaryColor || 'var(--color-grey-dark)'
    const tertiaryColor = ctx2.tertiaryColor || 'rgba(0, 0, 0, 0.04)'

    const lastMenus = [
        {
            menuLabel: "Settings",
            onClick: handleSettings,
            menuIcon: <Settings style={{ color: "var(--color-grey-dark)" }} />
        },
        {
            menuLabel: "LogoutSpan",
            onClick: handleLogout,
            menuIcon: <LogoutIcon style={{ color: "var(--color-grey-dark)" }} />
        }
    ]

    return (
        <div className='homepageTemplate'>
            <div className="homePageMenuTemplate" style={!showMenu ? { transform: 'translate(-233px,0) ', transition: '0.2s ease' } : { transform: 'translate(0,0) ', transition: '0.2s ease' }}>
                <div className='lateralMenuWrapper'>
                    <div className='lateralMenuScroll'>
                        {menus.map((menu, key) => (
                            <div style={{ marginTop: '10px' }} key={key}>
                                <Box sx={{ bgcolor: menu.menuOpen ? 'var(--color-grey-light2)' : 'var(--color-white)', pb: 0 }} >
                                    <Tooltip title={`${t(menu.menuLabel)}`} placement="right">
                                        <ListItem component="div" disablePadding
                                            sx={{
                                                "& .MuiListItemButton-root:hover ": { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
                                                '& .MuiListItemIcon-root': { minWidth: 0, marginRight: 2 }
                                            }}
                                        >
                                            <ListItemButton disableRipple
                                                style={{ borderRadius: '5px', paddingRight: '0px', paddingTop: '0px', paddingBottom: '0px', minHeight: '48px', marginRight: '0px', maxWidth: '220px' }}

                                                onClick={(event) => {
                                                    if (!menu?.subMenus || menu?.subMenus?.length === 0) {
                                                        setShowMenu(false)
                                                        ctx.newTab(`${menu?.menuUrl}`, menu?.menuDisplay, event)
                                                    } else {
                                                        setMenus(prev => prev.map(elem => {
                                                            if (menu?.menuLabel === elem.menuLabel) {
                                                                elem.menuOpen = !elem.menuOpen
                                                                if (elem.menuOpen) {
                                                                    return {
                                                                        ...elem,
                                                                        subMenus: elem.subMenus.map(subMenu => ({
                                                                            ...subMenu, subMenuOpen: false
                                                                        }))
                                                                    }
                                                                }
                                                                return elem
                                                            } else {
                                                                elem.menuOpen = false
                                                                return elem
                                                            }
                                                        }))
                                                    }
                                                }}
                                                onMouseDown={(event) => {
                                                    if (event.button === 1) {
                                                        if (menu?.subMenus.length === 0) {
                                                            document.body.onmousedown = e => { if (e.button === 1) return false }
                                                            ctx.newTab(`${menu?.menuLabelUrl}`, menu?.menuDisplay, event)
                                                        } else {
                                                            setMenus(prev => prev.map(elem => {
                                                                if (menu?.menuLabel === elem.menuLabel) {
                                                                    elem.menuOpen = !elem.menuOpen
                                                                    if (elem.menuOpen) {
                                                                        return {
                                                                            ...elem,
                                                                            subMenus: elem.subMenus.map(subMenu => ({
                                                                                ...subMenu, subMenuOpen: false
                                                                            }))
                                                                        }
                                                                    }
                                                                    return elem
                                                                } else {
                                                                    elem.menuOpen = false
                                                                    return elem
                                                                }
                                                            }))
                                                        }
                                                    }
                                                }}
                                            >
                                               {menu.menuOpen ?
                                                    menu?.menuImg ?
                                                        <img src={menu?.menuImg} alt={`${menu.menuLabel}`} className="ImageMainMenu" style={menu?.menuStyle} />
                                                        :
                                                        menu?.menuIcon && <div style={{ color: primaryColor, marginRight: '10px' }}>{menu?.menuIcon}</div>
                                                    :
                                                    menu?.menuImg ?
                                                        <img src={menu?.menuImg} alt={`${menu.menuLabel}`} className="ImageMainMenu" style={menu?.menuStyle} />
                                                        :
                                                        menu?.menuIcon && <div style={{ color: secondaryColor, marginRight: '10px' }} >{menu?.menuIcon}</div>
                                                }
                                                <ListItemText sx={{ my: 0 }}
                                                    primary={`${t(menu?.menuLabel)}`}
                                                    primaryTypographyProps={{
                                                        fontSize: 15, fontWeight: 'bold', lineHeight: '20px', mb: '2px',
                                                        color: menu?.menuOpen ? `${secondaryColor}` : 'var(--color-grey-dark)',
                                                        textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '127px'
                                                    }}
                                                    secondary={
                                                        menu?.menuOpen ? "" : menu?.subMenus?.map((el, index, array) => {
                                                            return index === array.length - 1 ? `${t(el.subMenuLabel)}` : `${t(el.subMenuLabel)},`
                                                        }).join('')
                                                    }
                                                    primaryTypographyProps={{
                                                        fontSize: 15,
                                                        fontWeight: 'bold',
                                                        lineHeight: '20px',
                                                        mb: '2px',
                                                        color: menu?.menuOpen ? primaryColor : secondaryColor,
                                                        textOverflow: 'ellipsis',
                                                        overflow: 'hidden',
                                                        whiteSpace: 'nowrap',
                                                        maxWidth: '127px'
                                                    }}
                                                    secondaryTypographyProps={{
                                                        noWrap: true,
                                                        fontSize: '13px',
                                                        lineHeight: '19px',
                                                        color: 'var(--color-grey)',
                                                        textOverflow: 'ellipsis',
                                                        overflow: 'hidden',
                                                        whiteSpace: 'nowrap',
                                                        maxWidth: '125px',
                                                        display: 'block'
                                                    }}

                                                />
                                                {menu?.subMenus && menu?.subMenus?.length > 0 ?
                                                    <IconButton size="large" disableRipple={true}
                                                        sx={{
                                                            "& svg": {
                                                                color: "rgba(255,255,255,0.8)",
                                                                transition: "0.2s",
                                                                transform: "translateX(0) rotate(0)",
                                                            },
                                                            "&:hover, &:focus": { bgcolor: "unset" },
                                                            "&::after": {
                                                                content: '""',
                                                                position: "absolute",
                                                                height: "80%",
                                                                display: "block",
                                                                left: 0,
                                                                width: "1px",
                                                            }
                                                        }}
                                                    >
                                                        {menu?.menuOpen ?
                                                            <KeyboardArrowDown style={{ color: menu?.menuOpen ? `${secondaryColor}` : 'var(--color-grey-dark)' }} /> :
                                                            <KeyboardArrowUP style={{ color: "var(--color-grey-dark)" }} />
                                                        }
                                                    </IconButton>
                                                    : <></>
                                                }
                                            </ListItemButton>
                                        </ListItem>
                                    </Tooltip>
                                    {menu?.menuOpen &&
                                        <div className="lateralMenuSubGroup">
                                        {menu?.subMenus.map((subMenu, key) => {
                                            const hasSubSubMenus = subMenu?.subSubMenus?.length > 0
                                            return (
                                            <div key={key}>
                                                <Tooltip title={`${t(subMenu?.subMenuLabel)}`} placement="right">
                                                    <ListItemButton
                                                        disableRipple={true}
                                                        key={subMenu?.subMenuLabel}
                                                        className={`lateralMenuSubItem${hasSubSubMenus ? ' lateralMenuSubItem--expandable' : ''}${subMenu?.subMenuOpen ? ' lateralMenuSubItem--active' : ''}`}
                                                        sx={{
                                                            color: subMenu?.subMenuOpen ? secondaryColor : 'var(--color-grey-dark)',
                                                            backgroundColor: subMenu?.subMenuOpen ? tertiaryColor : 'transparent',
                                                            ':hover': {
                                                                color: secondaryColor,
                                                                backgroundColor: tertiaryColor,
                                                            }
                                                        }}
                                                        onClick={(event) => {
                                                            if (!hasSubSubMenus) {
                                                                setShowMenu(false)
                                                                ctx.newTab(`${subMenu?.subMenuUrl}`, subMenu?.subMenuDisplay, event)
                                                            } else {
                                                                setMenus(prev => prev.map(elem => {
                                                                    if (elem.menuLabel === menu.menuLabel) {
                                                                        return {
                                                                            ...elem, subMenus: elem.subMenus.map(elem2 => {
                                                                                if (elem2.subMenuLabel === subMenu.subMenuLabel) {
                                                                                    elem2.subMenuOpen = !elem2.subMenuOpen
                                                                                } else {
                                                                                    elem2.subMenuOpen = false
                                                                                }
                                                                                return elem2
                                                                            })
                                                                        }
                                                                    } else {
                                                                        return elem
                                                                    }
                                                                }))
                                                            }
                                                        }}
                                                        onMouseDown={(event) => {
                                                            if (event.button === 1) {
                                                                if (!hasSubSubMenus) {
                                                                    document.body.onmousedown = e => { if (e.button === 1) return false }
                                                                    ctx.newTab(`${subMenu?.subMenuUrl}`, subMenu?.subMenuDisplay, event)
                                                                } else {
                                                                    setMenus(prev => prev.map(elem => {
                                                                        if (elem.menuLabel === menu.menuLabel) {
                                                                            return {
                                                                                ...elem, subMenus: elem.subMenus.map(elem2 => {
                                                                                    if (elem2.subMenuLabel === subMenu?.subMenuLabel) {
                                                                                        elem2.subMenuOpen = !elem2.subMenuOpen
                                                                                    } else {
                                                                                        elem2.subMenuOpen = false
                                                                                    }
                                                                                    return elem2
                                                                                })
                                                                            }
                                                                        } else {
                                                                            return elem
                                                                        }
                                                                    }))
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        {hasSubSubMenus && (
                                                            <ChevronRight
                                                                className={`lateralMenuSubItem-chevron${subMenu?.subMenuOpen ? ' open' : ''}`}
                                                                sx={{ color: subMenu?.subMenuOpen ? secondaryColor : 'var(--color-grey)' }}
                                                            />
                                                        )}
                                                        <ListItemText
                                                            primary={`${t(subMenu?.subMenuLabel)}`}
                                                            primaryTypographyProps={{
                                                                fontSize: '14px',
                                                                fontWeight: subMenu?.subMenuOpen ? 700 : 600,
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden',
                                                                whiteSpace: 'nowrap',
                                                                maxWidth: hasSubSubMenus ? '130px' : '160px',
                                                            }}
                                                            secondary={hasSubSubMenus && !subMenu?.subMenuOpen
                                                                ? subMenu.subSubMenus.slice(0, 3).map(el => t(el.subSubMenuLabel)).join(', ') + (subMenu.subSubMenus.length > 3 ? '…' : '')
                                                                : undefined}
                                                            secondaryTypographyProps={{
                                                                noWrap: true,
                                                                fontSize: '11px',
                                                                lineHeight: '14px',
                                                                color: 'var(--color-grey)',
                                                            }}
                                                        />
                                                    </ListItemButton>
                                                </Tooltip>
                                                {subMenu?.subMenuOpen && hasSubSubMenus &&
                                                    <div className="lateralMenuSubSubGroup">
                                                    {subMenu.subSubMenus.map((subSubMenu, subKey) => (
                                                        <div key={subKey}>
                                                            <Tooltip title={`${t(subSubMenu.subSubMenuLabel)}`} placement="right">
                                                                <ListItemButton
                                                                    key={subSubMenu.subSubMenuLabel}
                                                                    className="lateralMenuSubSubItem"
                                                                    sx={{
                                                                        color: 'var(--color-grey-dark)',
                                                                        ':hover': {
                                                                            color: secondaryColor,
                                                                            backgroundColor: tertiaryColor,
                                                                        },
                                                                    }}
                                                                    onClick={(event) => {
                                                                        setShowMenu(false)
                                                                        ctx.newTab(`${subSubMenu.subSubMenuUrl}`, subSubMenu.subSubMenuDisplay, event)
                                                                    }}
                                                                    onMouseDown={(event) => {
                                                                        if (event.button === 1) {
                                                                            document.body.onmousedown = e => { if (e.button === 1) return false }
                                                                            ctx.newTab(`${subSubMenu.subSubMenuUrl}`, subSubMenu.subSubMenuDisplay, event)
                                                                        }
                                                                    }}
                                                                >
                                                                    <ListItemIcon sx={{ minWidth: '18px' }}>
                                                                        <TripOriginIcon sx={{ fontSize: 8, color: secondaryColor }} fontSize="small" />
                                                                    </ListItemIcon>
                                                                    <ListItemText
                                                                        primary={`${t(subSubMenu.subSubMenuLabel)}`}
                                                                        primaryTypographyProps={{
                                                                            fontSize: '13px',
                                                                            fontWeight: 500,
                                                                            textOverflow: 'ellipsis',
                                                                            overflow: 'hidden',
                                                                            whiteSpace: 'nowrap',
                                                                            maxWidth: '140px',
                                                                        }}
                                                                    />
                                                                </ListItemButton>
                                                            </Tooltip>
                                                        </div>
                                                    ))}
                                                    </div>
                                                }
                                            </div>
                                        )})}
                                        </div>
                                    }
                                </Box>
                            </div>
                        ))}
                    </div>
                    <div className='lateralMenuFooter'>
                        {lastMenus.map((menu, key) => (
                            <ListItem component="div" disablePadding key={key}
                                sx={{ "& .MuiListItemButton-root:hover ": { backgroundColor: 'transparent' } }}
                            >
                                <ListItemButton sx={{ height: 40, cursor: 'default', maxWidth: '220px' }} disableRipple >
                                    <ListItemText primary={`${t(menu?.menuLabel)}`} primaryTypographyProps={{ color: "var(--color-grey-dark)", fontWeight: "bold" }} />
                                </ListItemButton>
                                <Tooltip title={`${t(menu?.menuLabel)}`} placement="right">
                                    <IconButton size="large" disableRipple={true} onClick={() => `${menu?.onClick()}`}
                                        sx={{
                                            "& svg": {
                                                color: "rgba(255,255,255,0.8)",
                                                transition: "0.2s",
                                                transform: "translateX(0) rotate(0)",
                                            },
                                            "&:hover, &:focus": {
                                                bgcolor: "unset",
                                                "& svg:first-of-type": { transform: "translateX(-4px) rotate(-20deg)" },
                                                "& svg:last-of-type": { right: 0, opacity: 1 }
                                            },
                                            "&::after": {
                                                content: '""',
                                                position: "absolute",
                                                height: "80%",
                                                display: "block",
                                                left: 0,
                                                width: "1px",
                                                bgcolor: "divider",
                                            },
                                        }}
                                    >
                                        {menu?.menuIcon}
                                        <ArrowRight
                                            style={{ color: "var(--color-grey-dark)" }}
                                            sx={{ position: "absolute", right: 4, opacity: 0 }}
                                        />
                                    </IconButton>
                                </Tooltip>
                            </ListItem>
                        ))}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '5px', marginBottom: '5px' }}>
                            <Tooltip title={"EN"} placement="top">
                                <img style={{ marginRight: '10px', cursor: 'pointer' }} onClick={() => handleChangeLng("en")} src='/icons/flagIcons/EN.png' alt="EN" width="40px" />
                            </Tooltip>
                            <Tooltip title={"ES"} placement="top">
                                    <img style={{ cursor: 'pointer' }} onClick={() => handleChangeLng("es")} src='/icons/flagIcons/ES.png' alt="ES" width="40px" />
                                </Tooltip>
                            <Tooltip title={"PT"} placement="top">
                                <img style={{ marginLeft: '10px', cursor: 'pointer' }} onClick={() => handleChangeLng("pt")} src='/icons/flagIcons/PT.png' alt="PT" width="40px" />
                            </Tooltip>
                        </div>
                        <div style={{ height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderTop: '1px solid var(--color-grey)', fontWeight: 'bold', color: 'var(--color-grey-dark)' }} >
                            <span style={{ width: '215px', textAlign: 'center' }}> {name} | {company} </span>
                        </div>
                    </div>
                </div>
            </div>
            {bodyPage}
        </div>
    )
}